import * as React from 'react';
import * as styles from './Column.css';

interface IColumnProps {
  marginLeft?: number;
  marginRight?: number;
}

export const Column: React.FC<React.PropsWithChildren<IColumnProps>> = ({ children, marginLeft, marginRight }) => {
  return (
    <div style={{ marginLeft, marginRight }} className={styles['column']}>
      {children}
    </div>
  );
};
